// extracted by mini-css-extract-plugin
export default {"addEmailWrapper":"styles_addEmailWrapper__0Dwt6","inputWrapper":"styles_inputWrapper__eyZ12"};